var getAttributesConfigurable = function getAttributesConfigurable(product) {
  var attrs = {};
  if (!product.options) {
    return attrs;
  }
  product.options.attributes.forEach(function (attribute) {
    attrs[attribute.attribute] = {
      label: attribute.label,
      name: attribute.attribute,
      items: product.options && product.options.items.reduce(function (accumulator, item) {
        var value = item.values.find(function (v) {
          return v.attribute === attribute.attribute;
        });
        if (value) {
          accumulator.push({
            buyRequest: item.buyRequest,
            product: item.product,
            label: value && value.value,
            price: item.price
          });
        }
        return accumulator;
      }, []),
      showConfigPrice: product.attributes.showConfigPrice !== undefined ? product.attributes.showConfigPrice : false
    };
  });
  return attrs;
};
var getSelectedConfigurable = function getSelectedConfigurable(options, configAttributes) {
  var keys = Object.keys(configAttributes);
  if (keys.length > 0 && options) {
    var firstKey = keys[0];
    if (configAttributes[firstKey]) {
      return configAttributes[firstKey].items.find(function (item) {
        return item.buyRequest === options[firstKey];
      });
    }
  }
  return null;
};

export { getAttributesConfigurable, getSelectedConfigurable };
//# sourceMappingURL=configurable-helpers.js.map
